<template>

  <div class="d-inline-block position-relative">
    <button
        :id="filter.name"
        class="btn btn-sm d-flex align-items-center gap-2 text-nowrap"
        :class="isOpen ? 'btn-secondary shadow-sm' : 'btn-white border bg-white text-secondary'"
        @click="toggleFilter"
        style="min-width: 120px; justify-content: space-between;"
    >
      <span class="text-truncate" style="max-width: 150px;">{{ filter.name }}</span>
      <i class="fas fa-caret-down small" :class="{ 'fa-rotate-180': isOpen }"></i>
    </button>

    <div
        v-show="isOpen"
        class="dropdown-menu show p-3 shadow border-0 mt-1"
        style="min-width: 280px; width: 100%; max-width: 320px; z-index: 1050; position: absolute;"
    >
      <div v-if="filter.filterType === 'MULTI_SELECT' || filter.filterType === 'SINGLE_SELECT'" class="mb-2">
        <div class="input-group input-group-sm">
          <span class="input-group-text bg-white border-end-0">
            <i class="fas fa-search text-muted"></i>
          </span>
          <input
              type="text"
              class="form-control border-start-0 ps-0"
              placeholder="Szukaj..."
              v-model="searchQuery"
              @input="onSearchInput"
          />
        </div>
      </div>

      <div v-show="filter.filterType === 'MULTI_SELECT'" class="form-check form-switch mb-2 border-bottom pb-2">
        <input
            class="form-check-input"
            type="checkbox"
            id="selectAll"
            v-model="areAllSelected"
            @change="toggleSelectAll"
        />
        <label class="form-check-label small fw-bold" for="selectAll">
          {{ areAllSelected ? 'Odznacz wszystkie' : 'Zaznacz wszystkie' }}
        </label>
      </div>

      <div
          v-show="filter.filterType === 'MULTI_SELECT' || filter.filterType === 'SINGLE_SELECT'"
          ref="filterList"
          class="filter-list custom-scrollbar"
          style="max-height: 200px; overflow-y: auto;"
          @scroll.passive="handleListScroll"
      >
        <div v-for="(value, index) in filteredValues" :key="index" class="form-check">
          <input
              v-if="filter.filterType === 'MULTI_SELECT'"
              class="form-check-input"
              type="checkbox"
              :id="'chk-' + filter.key + '-' + index"
              :value="value"
              v-model="selectedValues"
          />
          <input
              v-if="filter.filterType === 'SINGLE_SELECT'"
              class="form-check-input"
              type="radio"
              :name="filter.key"
              :id="'rad-' + filter.key + '-' + index"
              :value="value"
              v-model="selectedValues"
          />

          <label
              class="form-check-label text-break small"
              :for="(filter.filterType === 'MULTI_SELECT' ? 'chk-' : 'rad-') + filter.key + '-' + index"
          >
            {{ value }}
          </label>
        </div>

        <div v-if="filteredValues.length === 0" class="text-center text-muted small py-2">
          Brak wyników
        </div>
      </div>

      <div v-show="filter.filterType === 'RANGE_DATE'">
        <label class="form-label small fw-bold text-muted">Zakres dat:</label>
        <div class="row g-2">
          <div class="col-6">
            <div class="small text-muted mb-1">Od:</div>
            <input type="date" class="form-control form-control-sm" v-model="rangeStart" />
          </div>
          <div class="col-6">
            <div class="small text-muted mb-1">Do:</div>
            <input type="date" class="form-control form-control-sm" v-model="rangeEnd" />
          </div>
        </div>
      </div>

      <div v-show="filter.filterType === 'RANGE_NUMBER'">
        <label class="form-label small fw-bold text-muted">Zakres wartości:</label>
        <div class="row g-2">
          <div class="col-6">
            <div class="small text-muted mb-1">Od:</div>
            <input type="number" class="form-control form-control-sm" v-model="rangeMin" placeholder="Min" step="any" />
          </div>
          <div class="col-6">
            <div class="small text-muted mb-1">Do:</div>
            <input type="number" class="form-control form-control-sm" v-model="rangeMax" placeholder="Max" step="any" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";

export default {
  name: "CommonTableFilter2",
  props: {
    filter: {
      type: Object,
      required: true,
    },
    initialOpened: {
      type: Boolean,
      default: false,
    },
    filtersFetchMethod: {
      type: Function,
      required: true,
    },
    filtersFetchParams: {
      type: Object,
      required: false,
    }
  },
  emits: ["onSelectedValues"],
  data() {
    return {
      isOpen: false,
      searchQuery: "",
      filteredValues: this.filter.availableValues.content || [],
      infiniteScrollTotalPages: this.filter.availableValues.totalPages || 1,
      selectedValues: [],
      excludedValues: [],
      areAllSelected: false,
      rangeStart: "",
      rangeEnd: "",
      rangeMin: "",
      rangeMax: "",

      searchDebounceTimeout: null,
      fetchNextThresholdPx: 60,
      fetchNextLocked: false,
      pageNumber: 1,
      isInitializing: true,

    };
  },
  methods: {
    toggleFilter() {
      this.isOpen = !this.isOpen;
    },

    onSearchInput() {
      this.pageNumber = 1;
      this.filteredValues=[];
      const payload = {
        filterKey: this.filter.key,
        searchPhrase: this.searchQuery,
        pageNumber: this.pageNumber,
      }

      if (this.searchDebounceTimeout) {
        clearTimeout(this.searchDebounceTimeout);
      }


      if(this.searchQuery == null || this.searchQuery.length ===0){
        this.fetchValues(payload);
        return;
      }

      this.searchDebounceTimeout = setTimeout(() => {


        this.filteredValues = [];

        this.fetchValues(payload);

      }, 200);
    },

    handleListScroll(event) {
      const target = event.target;
      if (!target) {
        return;
      }

      const distanceToBottom = target.scrollHeight - target.scrollTop - target.clientHeight;

      if (distanceToBottom <= this.fetchNextThresholdPx && !this.fetchNextLocked) {
        this.fetchNextLocked = true;
        if(this.pageNumber >= this.infiniteScrollTotalPages){
          this.fetchNextLocked = false;
          return;
        }
        this.pageNumber = this.pageNumber + 1;
        const payload = {
          filterKey: this.filter.key,
          searchPhrase: this.searchQuery,
          pageNumber: this.pageNumber,
        }
        this.fetchValues(payload);

        setTimeout(() => {
          this.fetchNextLocked = false;
        }, 100);
      }
    },

    fetchValues(params){
      // merge filtersFetchParams with params
      params = {...this.filtersFetchParams, ...params};

      this.filtersFetchMethod(params).then((response) => {
        if (response.status === 200) {

          const filters = JSON.parse(JSON.stringify(response.data.payload)); //expected only one filter, because we`ve passed filterKey param
          if(filters.length > 0){
            const filter = filters[0];
            if(filter.availableValues){
              console.log("fetching next values for filter: " + filter.key,filter.availableValues.content);
              // adding fetched values to the existing ones
              this.infiniteScrollTotalPages = filter.availableValues.totalPages;
              this.filteredValues = [...(this.filteredValues || []), ...(filter.availableValues.content || [])];
              if (this.areAllSelected) {
                this.selectedValues = this.filteredValues.filter(value => !this.excludedValues.includes(value));
              }
            }

          }

        }
        return apiRequestsHelper.handleResponseWithDialogs(response, false);
      }).catch((error) => {
        return apiRequestsHelper.catchResponseError(error,"" + this.filtersFetchMethod);
      })


    },

    toggleSelectAll() {
      if (!this.areAllSelected) {
        this.selectedValues = [];
      } else {
        this.selectedValues = [...this.filteredValues];
      }
    },
  },
  watch: {
    selectedValues: {
      handler(newVal) {
        if (this.isInitializing) {
          return;
        }
        let newSelectedValues = [];
        let newExcludedValues = [];

        if (this.areAllSelected === true) {
          if(this.searchQuery && this.searchQuery.length > 0) {
            // if search query is active, we need to pass also selectedValues
            newSelectedValues = newVal;
          }else{
            newSelectedValues = []; // if there is no search query backend will consider all available options from db
          }

          newExcludedValues = this.filteredValues.filter(value => !newVal.includes(value));



        } else {
          if(this.searchQuery && this.searchQuery.length > 0){
            newExcludedValues = this.filteredValues.filter(value => !newVal.includes(value));
          }else{
            newExcludedValues = []; // if there is no search query backend will consider all available options from db
          }
          newSelectedValues = newVal;

        }

        const filterDto = {
          key: this.filter.key,
          name: this.filter.name,
          selectedValues: newSelectedValues,
          allSelected: this.areAllSelected,
          excludedValues: newExcludedValues,
        };

        this.$emit("onSelectedValues", filterDto);
      },
      deep: true,
    },

    rangeStart: {
      handler(newVal) {
        if (this.isInitializing) {
          return;
        }

        const filterDto = {
          key: this.filter.key,
          name: this.filter.name,
          selectedValues: [newVal, this.rangeEnd],
          allSelected: false,
          excludedValues: [],
        };

        this.$emit("onSelectedValues", filterDto);
      },
      deep: true,
    },

    rangeEnd: {
      handler(newVal) {
        if (this.isInitializing) {
          return;
        }

        const filterDto = {
          key: this.filter.key,
          name: this.filter.name,
          selectedValues: [this.rangeStart, newVal],
          allSelected: false,
          excludedValues: [],
        };

        this.$emit("onSelectedValues", filterDto);
      },
      deep: true,
    },

    rangeMin: {
      handler(newVal) {
        if (this.isInitializing) {
          return;
        }

        const filterDto = {
          key: this.filter.key,
          name: this.filter.name,
          selectedValues: [newVal, this.rangeMax],
          allSelected: false,
          excludedValues: [],
        };

        this.$emit("onSelectedValues", filterDto);
      },
      deep: true,
    },

    rangeMax: {
      handler(newVal) {
        if (this.isInitializing) {
          return;
        }

        const filterDto = {
          key: this.filter.key,
          name: this.filter.name,
          selectedValues: [this.rangeMin, newVal],
          allSelected: false,
          excludedValues: [],
        };

        this.$emit("onSelectedValues", filterDto);
      },
      deep: true,
    },
  },
  created() {

    console.log("creating filter: ", this.filter);

    this.selectedValues = Array.isArray(this.filter.selectedValues)
        ? [...this.filter.selectedValues]
        : [];

    this.excludedValues = Array.isArray(this.filter.excludedValues)
        ? [...this.filter.excludedValues]
        : [];

    this.areAllSelected = this.filter.allSelected === true;

    // if areAllSelected , then set selectedValues to all filtered values minus all excluded
    if (this.areAllSelected) {
      this.selectedValues = this.filteredValues.filter(value => !this.excludedValues.includes(value));
    }
    this.isOpen = this.initialOpened;
    this.$nextTick(() => {
      this.isInitializing = false;
    });
  },
  beforeUnmount() {
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.375rem;
}
</style>